// ets_tracing: off
import * as T from "@effect-ts/core/Sync";

class DecoderImpl {
  constructor(validate, codecType, name) {
    this.validate = validate;
    this.codecType = codecType;
    this.name = name;
    this.decode = this.decode.bind(this);
    this.with = this.with.bind(this);
  }

  decode(i) {
    return this.validate(i, [{
      key: "",
      actual: i,
      type: this
    }]);
  }

  with(validate) {
    return new DecoderImpl(validate, this.codecType, this.name);
  }

}

export function makeDecoder(validate, codecType, name) {
  return new DecoderImpl(validate, codecType, name);
}
export const failures = T.fail;
export const fail = (value, context, message) => failures([{
  value,
  context,
  message
}]);
export const appendContext = (c, key, decoder, actual) => {
  const len = c.length;
  const r = Array(len + 1);

  for (let i = 0; i < len; i++) {
    r[i] = c[i];
  }

  r[len] = {
    key,
    type: decoder,
    actual
  };
  return r;
};
//# sourceMappingURL=index.mjs.map